import type { ColumnDef } from '@/components/ui';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { IIssueCurrent } from '@skystone/shared';
import { issueCurrentApi } from '@/services/issue-current-api';
import { useApi } from '@/hooks/useApi';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const issueCurrentColumns: ColumnDef<IIssueCurrent>[] = buildRawColumns<IIssueCurrent>([
  { key: 'id', header: 'ID' },
  { key: 'issueKey', header: 'Issue Key' },
  { key: 'issueType', header: 'Issue Type' },
  { key: 'issueStatus', header: 'Issue Status' },
  { key: 'statusNormalized', header: 'Status Normalized' },
  { key: 'isDone', header: 'Is Done' },
  { key: 'createdDate', header: 'Created Date' },
  { key: 'updatedDate', header: 'Updated Date' },
  { key: 'resolvedDate', header: 'Resolved Date' },
  { key: 'firstInProgressDate', header: 'First In Progress Date' },
  { key: 'lastDoneDate', header: 'Last Done Date' },
  { key: 'daysInBacklog', header: 'Days In Backlog' },
  { key: 'daysInProgress', header: 'Days In Progress' },
  { key: 'transitionCount', header: 'Transition Count' },
  { key: 'lastTransitionAuthor', header: 'Last Transition Author' },
  { key: 'cycleTimeDays', header: 'Cycle Time Days' },
  { key: 'teamId', header: 'Team ID' },
  { key: 'teamName', header: 'Team Name' },
  { key: 'productId', header: 'Product ID' },
  { key: 'productName', header: 'Product Name' },
  { key: 'fabricTeamId', header: 'Fabric Team ID' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function IssueCurrentPage() {
  const { data: rows, loading, error } = useApi(() => issueCurrentApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader
        title="Tbl - issue_current"
        subtitle={buildStandardTblSubtitle()}
      />

      <ErrorBanner message={error} />

      <DataTable
        data={rows ?? []}
        columns={issueCurrentColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('issue current')}
      />
    </PageContainer>
  );
}
